import React, { useState, useEffect } from 'react'
import { Button, Col, Drawer, Panel, Row } from 'rsuite'
import AssetSendBackEditListsForm from './AssetSendBackEditListsForm'
import AssetSendBackEditListsTable from './AssetSendBackEditListsTable'
import { assetHistotry } from '../../../redux/actions/addDurableArticles'
import notification from '../../../utils/notification'
import { doneLoading, startLoading } from '../../../utils/loading'
import AssetHistoryTable from '../addDurableArticlesWidget/AssetHistoryTable'
import { budgetFormat } from '../../../utils/formatterUtil'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import { searchAssetBackEdit } from '../../../redux/actions/assetSendBackEditLists'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'

export default function AssetSendBackEditListsWidget(props) {
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [dataTable, setDataTable] = useState(props.schema.datas || [])
  const [historySchema, setHistorySchema] = useState()
  const [isShowHistory, setIsShowHistory] = useState(false)

  const handleViewHistory = async (rowData) => {
    // console.log('handleViewHistory ', rowData)

    setIsShowHistory(true)
    setIsLoading(true)
    startLoading()

    try {
      var response = await assetHistotry(rowData.id)
      if (response.model) {
        setHistorySchema(response.model)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
        setIsShowHistory(false)
      }
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 2500,
      })
      setIsShowHistory(false)
    }

    doneLoading()
    setIsLoading(false)
  }

  const onSearch = async (request) => {
    // console.log('onSearch', request)

    setIsLoading(true)
    startLoading()

    try {
      var response = await searchAssetBackEdit(request)
      console.log('response ', response.model)
      if (response.model) {
        setDataTable(response?.model)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={' '} bordered>
        {isLoading && <OverlayLoader />}

        <AssetSendBackEditListsForm
          schema={formSchema.searchForm}
          onSearch={onSearch}
          loading={isLoading}
        />

        <AssetSendBackEditListsTable
          schema={dataTable}
          loading={isLoading}
          onSelect={handleViewHistory}
        />

        <Drawer
          full
          // size="lg"
          show={isShowHistory}
          placement={'top'}
          onHide={() => {
            setIsShowHistory(false)
          }}
        >
          <Drawer.Header>
            <Drawer.Title style={{ height: 40, paddingTop: 10 }}>ประวัติครุภัณฑ์</Drawer.Title>
          </Drawer.Header>
          <Drawer.Body>
            {historySchema?.assetInfo && (
              <div style={{ width: '98%' }}>
                {historySchema.assetInfo.assetCode && (
                  <Row>
                    <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                      <b>{historySchema.assetInfo.assetCode.label}</b>
                    </Col>
                    <Col lg={20} md={20} sm={24} xs={24}>
                      {historySchema.assetInfo.assetCode.value}
                    </Col>
                  </Row>
                )}

                {historySchema.assetInfo.assetName && (
                  <Row>
                    <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                      <b>{historySchema.assetInfo.assetName.label}</b>
                    </Col>
                    <Col lg={20} md={20} sm={24} xs={24}>
                      {historySchema.assetInfo.assetName.value}
                    </Col>
                  </Row>
                )}

                <Row>
                  {historySchema.assetInfo.assetType && (
                    <>
                      <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                        <b>{historySchema.assetInfo.assetType.label}</b>
                      </Col>
                      <Col lg={8} md={8} sm={24} xs={24}>
                        {historySchema.assetInfo.assetType.value}
                      </Col>
                    </>
                  )}

                  {historySchema.assetInfo.price && (
                    <>
                      <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                        <b>{historySchema.assetInfo.price.label}</b>
                      </Col>
                      <Col lg={8} md={8} sm={24} xs={24}>
                        {budgetFormat(historySchema.assetInfo.price.value || 0)}
                      </Col>
                    </>
                  )}
                </Row>

                <br />
              </div>
            )}

            <AssetHistoryTable datas={historySchema?.values} loading={isLoading} />
          </Drawer.Body>
          <Drawer.Footer>
            <Button
              onClick={() => {
                setIsShowHistory(false)
              }}
              appearance="subtle"
            >
              ปิด
            </Button>
          </Drawer.Footer>
        </Drawer>
      </Panel>
    </>
  )
}
